import { Instance, SnapshotOut, types } from "mobx-state-tree";
import { OrderStoreModel } from "./OrderStore";
import { BottomBarStoreModel } from "./BottomBarStore";
import { VoucherStoreModel } from "./VoucherStore";
import { AboutUsModel } from "./AboutUsStore";
import { AfterSalesStoreModel } from "./AfterSalesStore";

/**
 * A RootStore model.
 */
export const RootStoreModel = types.model("RootStore").props({
  orderStore: types.optional(OrderStoreModel, {
    loading: true,
    orderType: "4096",
  }), // demo remove-current-line,
  bottomBarStore: types.optional(BottomBarStoreModel, {}),
  VoucherStore: types.optional(VoucherStoreModel, {
    currentPage: 1,
    pageSize: 12,
    total: 0,
    couponData: types.frozen(),
  }),
  aboutUsStore: types.optional(AboutUsModel, {}),
  AfterSalesStore: types.optional(AfterSalesStoreModel, {}),
});

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}
/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
